export default "__VITE_ASSET__BUOVfJRK__"